import memoizeOne from 'memoize-one';
import { LegacyDevice } from 'console/device/device';
export const memo_loc_info = memoizeOne((devices) => devices.map((dev) => ({
    id: dev.id,
    locations: dev.last_gps != null
        ? dev.last_gps.map((last_gps) => [last_gps.x, last_gps.y])
        : null,
    color: dev.color ?? '#c4443b',
    name: LegacyDevice.display_name({
        individual_device_name: dev.individual_device_name,
        name: dev.name,
    }),
})));
